import React, { useEffect, useState } from "react";

const DomainRenew = () => {
  const [domainDetails, setDomainDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const currentDomain = window.location.hostname;

  useEffect(() => {
    const checkDomainStatus = async () => {
      try {
        const response = await fetch(`https://cyberspacedigital.in/apis/Domain_Renew.php?domain=${currentDomain}`);
        const data = await response.json();

        if (data.error) {
          console.error(data.error);
        } else {
          setDomainDetails(data);
        }
      } catch (error) {
        console.error("Error fetching domain status:", error);
      } finally {
        setLoading(false);
      }
    };

    checkDomainStatus();
  }, [currentDomain]);

  if (loading) {
    return <div>Loading...</div>;
  }

  // ✅ Show Under Maintenance if server is "off"
  if (domainDetails?.server === "off") {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#f8f9fa",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
          flexDirection: "column",
          textAlign: "center",
          padding: "20px"
        }}
      >
        <h1 style={{ fontSize: "2rem", color: "#444" }}>Under Maintenance</h1>
        <p style={{ color: "#666", maxWidth: "500px" }}>
          We're currently performing scheduled maintenance for <strong>{domainDetails.domain}</strong>. Please check back soon!
        </p>
      </div>
    );
  }

  // ✅ If not expired, render nothing
  if (!domainDetails || !domainDetails.expired) {
    return null;
  }

  const { domain, user_name, purchased_date, expiry_date, tier, notes, invoice_paynow_url } = domainDetails;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 9999,
        backgroundColor: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          maxWidth: "600px",
          width: "100%",
          padding: "30px",
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          textAlign: "left",
        }}
      >
        <h2 style={{ marginTop: 0, color: "#333" }}>Domain Renewal</h2>
        <p><strong>Today's Date:</strong> {new Date().toLocaleDateString()}</p>
        <p style={{ fontSize: "1.1rem" }}>
          Your domain <strong>{domain}</strong> is{" "}
          <span style={{ color: "#e63946", fontWeight: "bold" }}>
            expired
          </span>.
        </p>
        <hr style={{ margin: "20px 0" }} />
        <p><strong>User Name:</strong> {user_name}</p>
        <p><strong>Purchased Date:</strong> {purchased_date}</p>
        <p><strong>Expiry Date:</strong> {expiry_date}</p>
        <p><strong>Tier:</strong> {tier}</p>
        <p><strong>Notes:</strong> {notes}</p>

        {invoice_paynow_url && (
          <div style={{ marginTop: "30px", textAlign: "center" }}>
            <a
              href={invoice_paynow_url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                padding: "12px 30px",
                backgroundColor: "#007bff",
                color: "white",
                fontSize: "1rem",
                textDecoration: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
            >
              Pay Now
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default DomainRenew;
